import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {withRouter} from 'react-router-dom'
import {withBoundary} from 'Components/ErrorBoundary'
import DocumentTitle from 'react-document-title'
import AccountSettings from './AccountSettings'
import Subscription from './Subscription'
import {Tabs} from 'antd'

import style from './style.sass'

@withBoundary
@withRouter
@inject('store') @observer
class Profile extends Component {
  changeTab = (key) => {
    key = key.replace(/[^\w\s]/gi, '')
    this.props.history.push({
      search: `tab=${key}`
    })
  }
  render() {
    const search = this.props.history.location.search
    const tab = search ? search.match(/tab=([^&]*)/)[1] : 'account'
    return(
      <div styleName='container'>
        <DocumentTitle title='My Profile'/>
        <Tabs type='card' onChange={this.changeTab} activeKey={tab}>
          <Tabs.TabPane tab='Account Settings' key='account'>
            <AccountSettings/>
          </Tabs.TabPane>
          <Tabs.TabPane tab='Subscription' key='subscription'>
            <Subscription/>
          </Tabs.TabPane>
        </Tabs>
      </div>
    )
  }
}

export default Profile
